import React, { FC, ReactNode } from "react"
import CopyButton from "./CopyButton"

interface InfoRowProps {
  label: string
  value: string | null | undefined
  copyable?: boolean
}

const InfoRow: FC<InfoRowProps> = ({ label, value, copyable = true }) => {
  const displayValue = value || '-'
  
  return (
    <div className="flex items-start py-3 border-b border-gray-200 gap-4">
      <div className="font-semibold text-gray-600 min-w-[120px] flex-shrink-0 pt-0.5">
        {label}
      </div>
      <div className="flex-1 min-w-0 text-gray-900 break-words whitespace-pre-line">
        {displayValue}
      </div>
      {copyable && displayValue !== '-' && (
        <div className="flex-shrink-0">
          <CopyButton text={displayValue} />
        </div>
      )}
    </div>
  )
}

interface InfoSectionProps {
  title: string
  children: ReactNode
}

const InfoSection: FC<InfoSectionProps> = ({ title, children }) => {
  return (
    <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
      <h3 className="text-lg font-semibold mb-4 text-primary border-b-2 border-primary pb-2">
        {title}
      </h3>
      <div>
        {children}
      </div>
    </div>
  )
}

export { InfoSection, InfoRow }

